import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import Dashboard from "./components/layouts/Dashboard";
import FnbDashboard from "./components/pages/FnbDashboard";
import FnbProducts from "./components/pages/FnbProducts";
import { useSelector } from "react-redux";
import NotesPopup from "./components/pages/NotesPopup";
import FnbPriceHistory from "./components/pages/FnbPriceHistory";
import DfDashboard from "./components/pages/DfDashboard";
import FnbReporting from "./components/pages/FnbReporting";
import DfProducts from "./components/pages/DfProducts";
import DfPriceHistory from "./components/pages/DfPriceHistory";
import Reporting from "./components/pages/Reporting";
import ChivasDior from "./components/pages/ChivasDior";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import DfWatchlist from "./components/pages/DfWatchlist";
import LiveMonitoring from "./components/pages/LiveMonitoring";
import Analytics from "./components/pages/Analytics";
import DfAiSummary from "./components/pages/DfAiSummary";
import DocumentPreview from "./components/layouts/DocumentPreview";
import Forgot from "./components/pages/Forgot";
import DocumentPreviewDutyFree from "./components/layouts/DocumentPreviewDutyFree";
import ProtectedRoute from "./components/elements/ProtectedRoute";

function App() {
  const popup = useSelector((state) => state.popup.notesPopup);

  return (
    <>
      {popup?.showNotes && <NotesPopup notes={popup.notes} />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="fnb-dashboard" element={
              <ProtectedRoute allowedOrganizationIds={[1, 2]}>
                <FnbDashboard />
              </ProtectedRoute>
            } />
            <Route path="fnb-products" element={
              <ProtectedRoute allowedOrganizationIds={[1, 2]}>
                <FnbProducts />
              </ProtectedRoute>
            } />
            <Route path="fnb-reporting" element={
              <ProtectedRoute allowedOrganizationIds={[1, 2]}>
                <FnbReporting />
              </ProtectedRoute>
            } />
            <Route path="df-watchlist" element={<DfWatchlist />} />
            <Route path="df-dashboard" element={<DfDashboard />} />
            <Route path="df-products" element={<DfProducts />} />
            <Route path="df-ai-summary" element={<DfAiSummary />} />
            <Route path="chivas-dior" element={
              <ProtectedRoute allowedOrganizationIds={[3]}>
                <ChivasDior />
              </ProtectedRoute>
            } />
            <Route path="live-monitoring" element={<LiveMonitoring />} />
            <Route path="reporting" element={<Reporting />} />
            <Route path="analytics" element={<Analytics />} />
          </Route>
          <Route path="/fnb-price-history/:id" element={
            <ProtectedRoute allowedOrganizationIds={[1, 2]}>
              <FnbPriceHistory />
            </ProtectedRoute>
          } />
          <Route path="/df-price-history/:id" element={<DfPriceHistory />} />
          <Route path="/document" element={<DocumentPreview />} />
          <Route path="/documentdf" element={<DocumentPreviewDutyFree />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer bodyClassName={() => "toast"} />
    </>
  );
}

export default App;
